import React from 'react';
import { IntlProvider } from 'react-intl';
import { getLocale } from '@raisin/cp-utils';
import { getRaisinAppProps } from '@raisin/cp-layout';
import { NotFoundPageComponent } from 'components/404';
import { getServerSideTranslations, setClientSideTranslations } from '../../../i18n';
import { useTranslationProvider } from '../../hooks';

export async function getStaticProps({ locale: localeProp, locales }) {
  const locale = getLocale(localeProp)?.intlFormat;
  const messages = await getServerSideTranslations({ locale, locales });
  const props = await getRaisinAppProps({ locale });
  return {
    props: { ...props, locale, messages },
    revalidate: 3600,
  };
}

const Custom404Page = ({ layout, locale, messages }) => {
  setClientSideTranslations(messages);
  useTranslationProvider({ locale });

  return (
    <IntlProvider messages={messages.translations} locale={locale}>
      <NotFoundPageComponent locale={locale} layout={layout} translations={messages.translations} />
    </IntlProvider>
  );
};

export default Custom404Page;
